// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import { generateScheduleGrid,setMinimumGird, insertT2050WorkCellsIntoGrid,insertSupportCellsIntoGrid } from '../C40101/comp/gridLayoutUtils';
import moment from 'moment';

/**
 * @type {import('vuex').Module}
 */
const module = {
  state: {
    C40201_doBrowseAll_M0040: []
  },

  getters: {
    C40201PDF_currentDate(state, getters, rootState) {
      const date = rootState.C40101.searchInfo.date;
      if (date && date.length > 0) {
        return date[0];
      }
      return moment().format('YYYY-MM-DD');
    },
    C40201_workingTeacherList (state,getters,rootState) {
      const lessons = rootState.C40101.lessons.filter(lesson => lesson.teacher_no > 0
        // && moment(rootState.C40101.searchInfo.date[0]) <= moment(lesson.lesson_date)
        // && moment(lesson.lesson_date) <= moment(rootState.C40101.searchInfo.date[1])
      );
      const teacherLessonCount = {};
      lessons.forEach(lesson => {
        if (!teacherLessonCount[lesson.teacher_no]) {
          teacherLessonCount[lesson.teacher_no] = 0;
        }
        teacherLessonCount[lesson.teacher_no]++;
      });

      const t2050Teachers = [...new Set(rootState.C40101.C40101T2050_rows.map((item)=>item.teacher_no))]

      return rootState.C40101.teachers.filter((t) => {
        if(
          (teacherLessonCount[t.teacher_no] && teacherLessonCount[t.teacher_no] > 0) ||
          t2050Teachers.includes(t.teacher_no)
        ) {
          return true;
        }
        return false;
      });
    },
    C40201_gridDataForCurrentDay(state,getters,rootState){
      return (teacherNo) => {
        const output = {};
        // ISSUE_LOW: Possible unused loop , 50,51,52 -> only 52 is used
        state.C40201_doBrowseAll_M0040.forEach(item => {
          const timeGroup = Math.floor(item.time_limit_no/10)
          const schedules =  rootState.C40101.lessons.filter(
            schedules =>
              schedules.teacher_no === teacherNo
            && timeGroup === Math.floor(schedules.time_limit_no/10)
          );

          let _gridData = generateScheduleGrid(schedules)
          _gridData= setMinimumGird(_gridData,2,2)          // Check for work cells and mark them as used slots

          for(let i=1;i<=2;i++){
            _gridData = insertT2050WorkCellsIntoGrid({
              teacherNo,
              currentDate: getters.C40201PDF_currentDate,
              timeLimitNo: timeGroup * 10 + i
            },
            rootState.C40101.C40101T2050_map,
            _gridData)
          }

          output[timeGroup] = _gridData;
        })

        // handle support
        const keyArr = Object.keys(output);
        for(let i=0; i<keyArr.length; i++) {
          const key = keyArr[i];
          output[key] = insertSupportCellsIntoGrid (output[key], {
            previousGridData: i > 0 ? output[keyArr[i-1]] : null,
            nextGridData: i < keyArr.length - 1 ? output[keyArr[i+1]] : null
          })
        }
        return output;
      }
    },
    C40201_gridDataForCurrentDayAndAllTeacher(state,getters,rootState){
      const output = {};
      getters.C40201_workingTeacherList.forEach(teacher => {
        output[teacher.teacher_no] = getters.C40201_gridDataForCurrentDay(teacher.teacher_no);
      })
      return output;
    }
  },
  mutations: {

  },
  actions: {
    async C40201_init({ commit, dispatch ,getters}, payload) {
      const res = await ApiUtils.postData({
        data: {
          C40201_doBrowseAll_M0040:{
            api: 'M0040TimeLimitService.C40201_doBrowseAll_M0040',
            input: {
              schedule_date: getters.C40201PDF_currentDate,
            }
          }
        }
      })

      commit('setState',{
        C40201_doBrowseAll_M0040 : res.C40201_doBrowseAll_M0040.output
      })
    }
  },
}



export default ObjArrUtils.merge(Base, module)
